import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import { Section, ImageContainer, Header, Container } from './styles'

const PressBanner = () => {
  const { today, cnet, wirecutter, verge, gma } = useStaticQuery(graphql`
    query PressBannerQuery {
      today: file(relativePath: { eq: "homepage/press/today.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      cnet: file(relativePath: { eq: "homepage/press/cnet.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      wirecutter: file(relativePath: { eq: "homepage/press/wirecutter.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      verge: file(relativePath: { eq: "homepage/press/verge.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      gma: file(relativePath: { eq: "homepage/press/gma.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  const images = [
    { alt: 'today', image: today },
    { alt: 'cnet', image: cnet },
    { alt: 'wirecutter', image: wirecutter },
    { alt: 'verge', image: verge },
    { alt: 'gma', image: gma },
  ]
  return (
    <Section>
      <Container>
        <Header>AS SEEN IN:</Header>
        {images.map(({ alt, image }) => (
          <ImageContainer key={alt} id={alt}>
            <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt={alt} />
          </ImageContainer>
        ))}
      </Container>
    </Section>
  )
}

export default PressBanner
